import type { UIMessage } from '@/lib/ivyChat/messageParser';
import type { StudioInput, StudioSlide } from '@/lib/studio/studioState';
import type { VideoOutline } from '@/types/outline';

/** The studio's input from what the workspace already holds: its outline, the chat, the manifest. */
export function studioInputFrom(opts: {
  outline: VideoOutline | null;
  messages: UIMessage[];
  isStreaming: boolean;
  hasManifest: boolean;
  manifestLoading?: boolean;
  /** The narration scripts the workspace already loaded; each has its audio length once recorded. */
  narration?: Array<{ slideIdentifier: string; script: { audioDuration?: number | null } | null }>;
}): StudioInput {
  const lengths = new Map((opts.narration ?? []).map((n) => [n.slideIdentifier, n.script?.audioDuration ?? undefined]));
  const slides: StudioSlide[] = (opts.outline?.slides ?? []).map((s) => ({
    id: s.id,
    order: s.order,
    title: s.title,
    ...(s.generationStatus && { generationStatus: s.generationStatus }),
    ...(s.generatedThumbnail && { generatedThumbnail: s.generatedThumbnail }),
    ...(typeof lengths.get(s.id) === 'number' && { audioDuration: lengths.get(s.id) as number }),
  }));
  return {
    messages: opts.messages,
    isStreaming: opts.isStreaming,
    slides,
    outlineApproved: opts.outline?.status === 'approved' || !!opts.outline?.approvedAt,
    hasManifest: opts.hasManifest,
    manifestLoading: !!opts.manifestLoading,
    isPublished: false,
  };
}
